'use strict';

export default class Carousel {
  constructor(context = document) {
    $('.paragraph--type--carousel-banner .field--name-field-slides', context).each(function () {
      const $carousel = $(this);
      const $carouselWrapper = $carousel.closest('.paragraph--type--carousel-banner');
      const isManualSlide = $carouselWrapper.hasClass('manual-slide');

      // Initialize Slick with conditional autoplay
      $carousel.slick({
        dots: true,
        arrows: true,
        autoplay: !isManualSlide, // Disable autoplay if manual slide is true
        autoplaySpeed: 5000,
        adaptiveHeight: true,
        speed: 500,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<button type="button" class="slick-prev"><svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.20874 1.5L1.45158 5.9726C1.37492 6.04025 1.31382 6.12194 1.27206 6.21265C1.23029 6.30336 1.20874 6.40116 1.20874 6.5C1.20874 6.59884 1.23029 6.69664 1.27206 6.78735C1.31382 6.87806 1.37492 6.95975 1.45158 7.0274L6.20874 11.5" stroke="white" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/></svg></button>',
        nextArrow: '<button type="button" class="slick-next"><svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.79126 11.5L6.54842 7.0274C6.62508 6.95975 6.68617 6.87806 6.72794 6.78735C6.76971 6.69664 6.79126 6.59884 6.79126 6.5C6.79126 6.40116 6.76971 6.30336 6.72794 6.21265C6.68617 6.12194 6.62508 6.04025 6.54842 5.9726L1.79126 1.5" stroke="white" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/></svg></button>',
      });

      // Move controls into a wrapper
      const $controls = $('<div class="slick-controls-wrapper"><div class="slick-controls-wrapper-inner"></div></div>');
      const $dots = $carousel.find('.slick-dots');
      const $prev = $carousel.find('.slick-prev');
      const $next = $carousel.find('.slick-next');

      // Create play/pause button only if not manual slide
      if (!isManualSlide) {
        const $playPauseBtn = $('<button type="button" class="slick-playpause pause"><span class="visually-hidden">Pause</span></button>');
        
        // Rearrange controls with play/pause button
        $controls.find('.slick-controls-wrapper-inner').append($prev, $playPauseBtn, $dots, $next);
        
        // Play/pause functionality
        $playPauseBtn.on('click', function () {
          const $this = $(this);
          if ($this.hasClass('pause')) {
            $carousel.slick('slickPause');
            $this.removeClass('pause').addClass('play');
            $this.find('.visually-hidden').text('Play');
          } else {
            $carousel.slick('slickPlay');
            $this.removeClass('play').addClass('pause');
            $this.find('.visually-hidden').text('Pause');
          }
        });
      } else {
        // Rearrange controls without play/pause button
        $controls.find('.slick-controls-wrapper-inner').append($prev, $dots, $next);
      }
      
      $carousel.append($controls);
    });
  }
}
